const url = "/permissaoptarags";
const id = "idenPermissaoPtaRag";

export const initFormAndamento = {
  idenAndamento: null,
  dataAndamento: "",
  descAndamento: "",
  ptaRag: null,
};

export function salvar(parm) {
  return new Promise(async (resolve, _reject) => {
    if (parm[id] && parm[id] !== 0) {
      await atualizar(parm).then((res) => {
        resolve(res);
      });
    } else {
      await criar(parm).then((res) => {
        resolve(res);
      });
    }
  });
}

export function atualizar(parm) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`${url}/${parm[id]}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function criar(parm) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`${url}/${parm.ptaMonitora.idenPtaMonitora}`, JSON.stringify(parm)).then((res) => {
      resolve(res.data);
    });
  });
}

export function excluir(idenAndamento) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`${url}/${idenAndamento}`).then((res) => {
      resolve(res);
    });
  });
}

export function buscarPermissoesItem(idenPtaRag, page, size) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`${url}/listar/${idenPtaRag}?page=${page}&size=${size}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarPermissao(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`${url}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarPermissaoUoPrograma(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`${url}/uoprograma`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}
export function adicionarPermissaoPrograma(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/permissaoptarags/uoprograma`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function removerPermissaoUsuario(body) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`${url}`, JSON.stringify(body)).then((res) => {
      resolve(res.data);
    });
  });
}
export function removerPermissaoUsuarioUO(body) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/permissaoptarags/uoprograma`, JSON.stringify(body)).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarArvoreRag() {
  return new Promise(async (resolve, _reject) => {
    await window.$http.get(`/arvoresrag/carregar`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarArvoreRagOrgaos(idenExercicio) {
  return new Promise(async (resolve, _reject) => {
    await window.$http.get(`/arvoresrag/orgaos/${idenExercicio}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarArvoreRagUos(idenOrgao) {
  return new Promise(async (resolve, _reject) => {
    await window.$http.get(`/arvoresrag/uos/${idenOrgao}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function listarPermissaoPtaMonitora(ptaMonitoraKey) {
  return new Promise(async (resolve, _reject) => {
    await window.$http.get(`/permissaoptarags/listar/${ptaMonitoraKey}?page=0&size=10`).then((res) => {
      resolve(res.data);
    });
  });
}

export function getArvoreRag(idenOrgao, idenUo) {
  return new Promise(async (resolve, _reject) => {
    window.$http.get(`/arvoresrag/visoes/${idenOrgao}/${idenUo}`).then((res) => {
      resolve(res);
    });
  });
}

export function getUsersNoPaginate(queryParams) {
  return new Promise(async (resolve, _reject) => {
    window.$http.post(`/seguranca/contasacesso/buscarNome?page=0&size=10`, JSON.stringify(queryParams)).then((res) => {
      resolve(res);
    });
  });
}

export function getUsersPaginate(queryParams, page) {
  return new Promise(async (resolve, _reject) => {
    window.$http
      .post(`/seguranca/contasacesso/buscarNome?page=${page}&size=10`, JSON.stringify(queryParams))
      .then((res) => {
        resolve(res);
      });
  });
}
